// useFileUpload.js
import { useState } from "react";
import { toast } from "react-toastify";

import { api } from "../utils/axios/Config";
import { handleErrorApi } from "../utils/utils";

const useFileUpload = () => {
  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const uploadFile = async ({ file, pic_type }) => {
    if (file.size > import.meta.env.VITE_MAX_SIZE_UPLOAD) {
      toast("حجم فایل بیش از مقدار مجاز است");
      return;
    }
    const getUploadUrl = async (file) => {
      const fileType = file.type;
      if (fileType.includes("image")) {
        return `/generals/upload/pictures/`;
      } else if (
        fileType.includes("pdf") ||
        fileType.includes("word") ||
        fileType.includes("sheet") ||
        fileType.includes("xlsx") ||
        fileType.includes("xls") ||
        fileType.includes("csv")
      ) {
        return `/generals/upload/documents/`;
      }
      return `/generals/upload/files/`; // Fallback URL if needed
    };

    const uploadUrl = await getUploadUrl(file);

    try {
      setUploading(true);
      setProgress(0);
      setError(null);

      const response = await api.post(
        uploadUrl,
        { file: file, pic_type: pic_type },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setProgress(percentCompleted);
          },
        },
      );

      setUploading(false);
      return response;
    } catch (error) {
      console.log({ error });
      handleErrorApi(error);
      setUploading(false);
      setError(error.response?.data?.detail);
    }
  };

  return {
    progress,
    uploading,
    error,
    uploadFile,
  };
};

export default useFileUpload;
